function maskClientId(clientId) {
  const value = String(clientId || "").trim();
  if (!value) return "";
  if (value.length <= 8) return `${value.slice(0, 2)}…${value.slice(-2)}`;
  return `${value.slice(0, 4)}…${value.slice(-4)}`;
}

function logGoogleClientIdSource(source, clientId) {
  if (typeof process !== "undefined" && process.env?.NODE_ENV === "production") return;
  if (typeof console === "undefined" || typeof console.debug !== "function") return;
  console.debug(`[google-client-id] source=${source} client_id=${maskClientId(clientId) || "unset"}`);
}

export function getGoogleClientId() {
  const craClientId = String(process.env.REACT_APP_GOOGLE_CLIENT_ID || "").trim();
  if (craClientId) {
    logGoogleClientIdSource("cra", craClientId);
    return craClientId;
  }

  logGoogleClientIdSource("none", "");
  return "";
}

export function getGoogleClientIdDiagnostics() {
  const clientId = String(process.env.REACT_APP_GOOGLE_CLIENT_ID || "").trim();
  return {
    envPresent: Boolean(clientId),
    maskedClientId: maskClientId(clientId),
    source: "REACT_APP_GOOGLE_CLIENT_ID",
  };
}

export function resolveGoogleClientId() {
  return getGoogleClientId();
}
